"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDirFromProps;

var _useWebChatAPIContext = _interopRequireDefault(require("./useWebChatAPIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useDirFromProps() {
  return [(0, _useWebChatAPIContext.default)().dir];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VEaXJGcm9tUHJvcHMuanMiXSwibmFtZXMiOlsidXNlRGlyRnJvbVByb3BzIiwiZGlyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFZSxTQUFTQSxlQUFULEdBQTJCO0FBQ3hDLFNBQU8sQ0FBQyxxQ0FBdUJDLEdBQXhCLENBQVA7QUFDRCIsInNvdXJjZVJvb3QiOiJjb21wb25lbnQ6Ly8vIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHVzZVdlYkNoYXRBUElDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdEFQSUNvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VEaXJGcm9tUHJvcHMoKSB7XG4gIHJldHVybiBbdXNlV2ViQ2hhdEFQSUNvbnRleHQoKS5kaXJdO1xufVxuIl19